export enum BrowserName {
  CHROME = "chrome",
  FIREFOX = "firefox",
  SAFARI = "safari"
}

export interface CapabilitiyStep {
  description?: string;
  image?: NodeRequire;
}
